<template>
  <div v-if="isLoaded">
    <v-row>
      <v-col cols="8" lg="10" md="9" sm="8" v-if="filteredFront.length">
        <p>Select the rows you'd like to cover.</p>
        <v-select
        label="Front Seat"
        :items="filteredFront"
        :value="variations.front"
        item-text="svDescription"
        @change="fronter"
        return-object
        ></v-select>
      </v-col>
      <v-col cols="4" lg="2" md="3" sm="4">
        <SeatDrawing :seat="variations.front" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="10" md="9" sm="8" v-if="filteredRear.length">
        <v-select
        label="Rear Seat"
        :items="filteredRear"
        :value="variations.rear"
        item-text="svDescription"
        @change="rearer"
        return-object
        ></v-select>
      </v-col>
      <v-col cols="4" lg="2" md="3" sm="4">
        <SeatDrawing :seat="variations.rear" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="10" md="9" sm="8" v-if="filteredThird.length">
        <v-select
        label="Third Seat"
        :items="filteredThird"
        :value="variations.third"
        item-text="svDescription"
        @change="thirder"
        return-object
        ></v-select>
        <v-alert
        border="left"
        colored-border
        type="error"
        elevation="2">
         If your vehicle has <strong>more than 3 rows of seats</strong>, please call use toll-free to order.
      </v-alert>
      </v-col>
      <v-col cols="4" lg="2" md="3" sm="4">
        <SeatDrawing :seat="variations.third" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert
        border="left"
        colored-border
        type="error"
        elevation="2">
        Seat images represent basic seat styles. They are not intended to match your vehicle's seats exactly.
        If you don't see your seat style or you're not sure which to choose, or if your vehicle has more than three rows, please call us toll-free at <a href="tel:800-453-8830">800-453-8830</a>. Covers for armrests and adjustable headrests are sold separately. Select them when choosing options.
      </v-alert>
    </v-col>
  </v-row>
  <Navigate next :valid="isValidated" />
</div>
</template>

<style scoped lang="scss">
.seat-drawing {
  max-width: 100%;
}
::v-deep .v-list-item__title {
  white-space: pre-wrap !important;
}
::v-deep .v-alert__icon {
  display: none !important;
}
::v-deep .v-alert__content {
  padding-right: 20px;
  padding-left: 20px;
}
</style>

<script>
  import { mapState } from 'vuex'
  import { hasValues, filterVariations } from '@/utils'
  import { filterOptions } from '@/services/assets'
  import Variations from '@/services/variations'
  import Prices from '@/services/prices'
  import SeatDrawing from './SeatDrawing'
  import Navigate from './Navigate'

  export default {
    components: {
      SeatDrawing,
      Navigate
    },
    data () {
      return {
        front: [],
        rear: [],
        third: [],
        prices: []
      }
    },
    computed: {
      ...mapState([
        'year',
        'make',
        'model',
        'attributes',
        'variations',
        'optionPrices'
      ]),
      filteredFront(){
        return filterVariations(this['front'], this.attributes)
      },
      filteredRear() {
        return filterVariations(this['rear'], this.attributes)
      },
      filteredThird() {
        return filterVariations(this['third'], this.attributes)
      },
      isLoaded: function() {
        return this.model
        && (!this.hasAttributes
          || (this.hasAttributes
            && hasValues(this.attributes)))
      },
      isValidated: function() {
        return !!(Object.keys(this.variations).length && Object.values(this.variations).every(position => Object.keys(position).length))
      },
      hasAttributes: function() {
        return !!Object.keys(this.attributes).length
      },
    },
    watch: {
      'model': function (model) {
        this.front = this.rear = this.third = []
        this.$store.commit('resetVariations', {})
        if (model) {
          this.getVariations(this.year, this.make.makeId, model.modelId, 'front')
          this.getVariations(this.year, this.make.makeId, model.modelId, 'rear')
          this.getVariations(this.year, this.make.makeId, model.modelId, 'third')
        }
      },
    },
    methods: {
      async getVariations (year, make, model, row) {
        this[row] = await Variations.get(year, make, model, row)
      },
      fronter: function(variation) {
        this.handler('front', variation)
      },
      rearer: function(variation) {
        this.handler('rear', variation)
      },
      thirder: function(variation) {
        this.handler('third', variation)
      },
      async handler (row, variation) {
        const seatClass = variation.smClass
        if (this.prices[seatClass]) {
          variation.prices = this.prices[seatClass]
        } else {
          variation.prices = this.prices[seatClass] = await Prices.get(seatClass)
        }
        variation.options = filterOptions(variation, this.optionPrices)
        this.$store.commit('setVariations', { row, ...variation })
      }
    }
  }
</script>
